import { mapValues, mapKeys, snakeCase } from 'lodash';
import { unparse } from 'papaparse';
import { SchemaBuilder } from '../';
import { $ } from '../../simpli';
import { Helper } from '../../main';
var Schema = /** @class */ (function () {
    function Schema() {
    }
    Object.defineProperty(Schema.prototype, "allFields", {
        get: function () {
            return Object.keys(this.fieldSet);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Schema.prototype, "allHeaders", {
        get: function () {
            var _this = this;
            return this.allFields.map(function (fieldName) { return _this.translateFrom(fieldName); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Schema.prototype, "header", {
        get: function () {
            var _this = this;
            return mapValues(this.fieldSet, function (fieldController, fieldName) { return _this.translateFrom(fieldName); });
        },
        enumerable: true,
        configurable: true
    });
    Schema.prototype.translateFrom = function (fieldName) {
        var defaultI18nPath = ("" + Schema.defaultI18nPath)
            .replace(/{schemaName}/, this.name)
            .replace(/{fieldName}/, fieldName);
        return $.t(defaultI18nPath);
    };
    Schema.prototype.build = function (model, fieldName) {
        return new SchemaBuilder(this, model, fieldName);
    };
    Schema.prototype.getModelData = function (model) {
        var data = {};
        for (var _i = 0, _a = this.allFields; _i < _a.length; _i++) {
            var field = _a[_i];
            data[field] = this.build(model, field).getData();
        }
        return data;
    };
    Schema.prototype.getAjvSchema = function (model) {
        var schema = {
            properties: {},
        };
        for (var _i = 0, _a = this.allFields; _i < _a.length; _i++) {
            var field = _a[_i];
            var schemaFromField = this.build(model, field).getAjv();
            if (schemaFromField) {
                schema.properties[field] = schemaFromField;
            }
        }
        return schema;
    };
    Schema.prototype.validateErrors = function (model) {
        return $.ajv.validateErrors(this.getAjvSchema(model), model);
    };
    Schema.prototype.validate = function (model, showErrorMessage) {
        if (showErrorMessage === void 0) { showErrorMessage = true; }
        var errors = this.validateErrors(model);
        if (errors) {
            var error = errors[0];
            var fieldName = error.dataPath.replace(/^\./, '');
            var message = this.translateFrom(fieldName) + " - " + error.message;
            if (showErrorMessage) {
                Helper.errorValidation(message);
            }
            throw message;
        }
    };
    Schema.prototype.toList = function (list) {
        var _this = this;
        return list.map(function (item) { return _this.getModelData(item); }).map(function (data) {
            // Translate the keys
            return mapKeys(data, function (val, fieldName) { return _this.translateFrom(fieldName); });
        });
    };
    Schema.prototype.toCsv = function (list) {
        return unparse(this.toList(list));
    };
    Schema.prototype.toJson = function (list) {
        return JSON.stringify(this.toList(list));
    };
    Schema.prototype.downloadCsv = function (list, customTitle) {
        if (list.length) {
            var title = customTitle ? customTitle + ".csv" : snakeCase(this.name || 'document') + ".csv";
            Helper.createCsvFile(title, this.toCsv(list));
        }
    };
    Schema.defaultI18nPath = 'schema.{schemaName}.{fieldName}';
    return Schema;
}());
export { Schema };
//# sourceMappingURL=Schema.js.map